import type { ThumbnailNavItemSet } from "./types.ts";

export const THUMBNAIL_CONTAINER_ELEMENT_ID = "thumbnails-container";

export const getThumbnailContainerElementId = (thumbnailSetType: ThumbnailNavItemSet["type"]) =>
  `${THUMBNAIL_CONTAINER_ELEMENT_ID}-${thumbnailSetType}`;
